module.exports = __webpack_public_path__ + "img/m4.fe61798b.png";